// Module
var code = `<h2 class="section-header">Interest rate board:</h2>
<div class="alert">
  Please note: In case of duplicated or missing rows default rate will be used for calculation
</div>
<div class="form-section">
  <div>
    <div class="form-section-field-title">
      Min. interest rate
    </div>
    <glue-container append-percentage="true">
      <input
        required
        disabled
        ng-model="\$ctrl.minInterestRate">
    </glue-container>
  </div>
  <div>
    <div class="form-section-field-title">
      Max. interest rate
    </div>
    <glue-container append-percentage="true">
      <input
        required
        disabled
        ng-model="\$ctrl.maxInterestRate">
    </glue-container>
  </div>
  <div>
    <div class="form-section-field-title">
      Default interest rate
    </div>
    <glue-container append-percentage="true">
      <input
        required
        disabled
        ng-model="\$ctrl.defaultInterestRate">
    </glue-container>
  </div>
  <div>
    <div class="form-section-field-title">
      Allow override
    </div>
    <select required
            boolean-options
            ng-model="\$ctrl.board.allowOverride">
    </select>
  </div>
</div>

<table class="table table--generate-row-ids">
  <thead>
  <tr>
    <th>No.</th>
    <th>Min term (inclusive)</th>
    <th>Max term (exclusive)</th>
    <th>Interest rate</th>
    <th>Action</th>
  </tr>
  </thead>
  <tbody>
  <tr ng-repeat="cell in \$ctrl.board.cells">
    <td></td>
    <td>
      <glue-container
        append="'days'">
        <input class="input-days"
               required
               type="number"
               min="0"
               max="100000"
               step="1"
               ng-model="cell.minTerm">
      </glue-container>
    </td>
    <td>
      <glue-container append="'days'">
        <input class="input-days"
               type="number"
               min="0"
               max="100000"
               step="1"
               ng-model="cell.maxTerm">
      </glue-container>
    </td>
    <td>
      <glue-container append-percentage="true">
        <input
          required
          type="number"
          min="{{\$ctrl.minInterestRate}}"
          max="{{\$ctrl.maxInterestRate}}"
          step="0.00001"
          ng-model="cell.interestRate">
      </glue-container>
    </td>
    <td>
      <button type="button" class="btn btn-danger" ng-click="\$ctrl.removeBoardCell(\$index)">
        Remove
      </button>
    </td>
  </tr>
  </tbody>
  <tfoot>
  <tr>
    <td colspan="4"></td>
    <td>
      <button type="button" class="btn btn-primary" ng-click="\$ctrl.addNewBoardCell()">
        Add new
      </button>
    </td>
  </tr>
  </tfoot>
</table>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/loan/details/forms/loan-interest-rate-board.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;